<div class="wizard position-relative flex-grow-1 d-flex flex-column" [@wizardAnimation]="currentStep">
  <ng-container [ngSwitch]="currentStep">
    <app-step1 *ngSwitchCase="'step1'" (next)="onNext()"></app-step1>
    <app-step2
      *ngSwitchCase="'step2'"
      [countryList]="countryList"
      [timeZones]="timeZones"
      [currencies]="currencies"
      (back)="onBack()"
      (submitted)="onSubmitted($event)"
    ></app-step2>
    <app-thankyou *ngSwitchCase="'thankyou'"></app-thankyou>
  </ng-container>
</div>
